import React from 'react'
import { Carousel } from 'react-bootstrap'
// import 'normalize.css/normalize.css'
import './slider-animations.css'
import './styles.css'

const content = [
  {
    image: 'images/outings/2019Trip1.jpg',
  },
  {
    image: 'images/outings/2019Trip2.jpg',
  },  
  {
    image: 'images/outings/officeCelebration1.jpg',
  },
  {
    image: 'images/outings/officeCelebration2.jpg',
  },
  {
    image: 'images/outings/officeCelebration3.jpg',
  },
  {
    image: 'images/outings/officeCelebration4.jpg',
  },
  {
    image: 'images/outings/trip2018-2.jpg',
  },
  {
    image: 'images/outings/2018Trip2.jpg',
  },
  {
    image: 'images/outings/outing2018.jpg',
  },
  {
    image: 'images/outings/DSC06046.jpg',
  },
  {
    image: 'images/outings/outings6.jpg',
  },
  {
    image: 'images/outings/outings5.jpg',
  },
  {
    image: 'images/outings/outings1.jpg',
  },
  {
    image: 'images/outings/outings3.jpg',
  },
  {
    image: 'images/outings/outings4.jpg',
  },
  {
    image: 'images/outings/outings2.jpg',
  },
  {
    image: 'images/outings/DSC_0009.jpg',
  },
  {
    image: 'images/outings/DSC06092.jpg',
  },
  {
    image: 'images/outings/15.jpg',
  },
  {
    image: 'images/outings/38.jpg',
  },
  {
    image: 'images/outings/74.jpg',
  },
]

const Team = () => (
  <div id="team">
    <br />
    <br />
    <h1 id="team" className="title text-center" style={{ marginTop: '4.5%' }}>
        Team
    </h1>
    <div style={{
 marginTop: '3%', marginLeft: '5%', marginRight: '5%', marginBottom: '3%',
}}>
      <Carousel style={{ height: '100%', width: '100%' }} interval={4000}>
        {content.map((item, index) => (
          <Carousel.Item key={index} >
            <center>
              <div id="teamImages" className="img-responsive">
                <img src={item.image} />
              </div>
            </center>
          </Carousel.Item>
        )
      )
    }
      </Carousel>
    </div>
  </div>
)
export default Team



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/team.js